<main>
  <app-home-pricing/>
  <app-home-bottom-links/>
</main>
<p-toast/>
